export default __webpack_public_path__ + "media/c8ea6746b36755ebd490f2807e1e5e5c3a87afbeb5e8351729b56f56be272e4e.svg";